
let discountAmount = window.identifiersData && window.identifiersData[1].discount_amount

localStorage.setItem(`__customDiscount__`, JSON.stringify(_customDiscount_));

const storageReferralCode = localStorage.getItem(`__referralRedirect__`);
const isCustomerRR = localStorage.getItem(`__isCustomerRR__`);
let discountCodes = getCookie('custom_discounts');

if (discountCodes) {
    discountCodes = discountCodes.split(',')
}

automaticDiscountObject = []

$(document)
    .ready(async function () {

        await getDiscountCustom();

        const storageReferralCode = localStorage.getItem(`__referralRedirect__`);
        const isCustomerRR = localStorage.getItem(`__isCustomerRR__`);
        let discountCodes = getCookie('custom_discounts') || [];

        if (discountCodes && typeof(discountCodes) == "string") {
            discountCodes = discountCodes.split(',')
        }

        if(storageReferralCode) {
            discountCodes.push(storageReferralCode);
        }

        let itemUpdates = [];

        let itemAdds = [];

        // manualDiscountObject = _customDiscount_.filter(x => x.flat_offer == 0 && !x.offers.some(x => x.discount_type == "gift"));

        // if (typeof manualDiscountObject !== 'undefined' && manualDiscountObject && discountCodes) {

        //     manualDiscountObject.forEach(async discountManaul => {
        //         manualPromises = [];

        //         discountManaul.offers.forEach(async offersObject__manual => {

        //             let requiredAttribute = discountManaul.promotion_code.toLowerCase().trim();

        //             if (typeof offersObject__manual !== 'undefined' && offersObject__manual && discountCodes.some(discount => discount.startsWith(discountManaul.promotion_code))) {

        //                 if (typeof offersObject__manual.product_selectors !== 'undefined' && offersObject__manual.product_selectors) {

        //                     offersObject__manual.product_selectors.forEach(async o => {
        //                         if ($(`.cart__row[vid="${o}"]`).length > 0) {
        //                             const getQTY = $(`.cart__row[vid="${o}"]`).attr(`data-cart-item-quantity`) * 1;
        //                             const properties = JSON.parse($(`.cart__row[vid="${o}"]`).attr(`data-properties`) || '[]');
        //                             var old_prop = properties.reduce(function (map, obj) {
        //                                 map[obj[0]] = obj[1];
        //                                 return map;
        //                             }, {});

        //                             old_prop[requiredAttribute] = true;

        //                             var existItemUpdate = itemUpdates.find(x => x.id == o);

        //                             if (existItemUpdate) {
        //                                 var indexItemExist = itemUpdates.findIndex(x => x.id == o);

        //                                 itemUpdates[indexItemExist] = {
        //                                     ...existItemUpdate,
        //                                     properties: {
        //                                         ...existItemUpdate.properties,
        //                                         ...old_prop
        //                                     }
        //                                 }

        //                             } else {
        //                                 var itemUpdating = {
        //                                     id: `${o}`,
        //                                     quantity: getQTY || 1,
        //                                     properties: {
        //                                         ...old_prop
        //                                     }
        //                                 }

        //                                 itemUpdates.push(itemUpdating)
        //                             }

        //                         }

        //                     });



        //                 }

        //             }
        //         })
        //     })

        // } else {


        // }

        // /* automatic gift */

        // automaticDiscountObject = _customDiscount_.filter(x => x.flat_offer == 1 && x.offers.some(x => x.discount_type == "gift"));

        // if (typeof automaticDiscountObject !== 'undefined' && automaticDiscountObject) {

        //     automaticDiscountObject.forEach(async automaticDiscount => {
        //         offersObject__gift = findObjectByKey(automaticDiscount.offers, `discount_type`, `gift`);

        //         let offerObject__notGift = automaticDiscount.offers.filter(x => x.discount_type != `gift`);

        //         if (typeof offersObject__gift !== 'undefined' && offersObject__gift) {

        //             if (typeof offersObject__gift.mandatory_product_selectors !== 'undefined' && offersObject__gift.mandatory_product_selectors) {

        //                 const cartRowArray = document.querySelectorAll(`tbody[data-cart-line-items] .cart__row`);

        //                 const requiredAttribute = automaticDiscount.promotion_code.toLowerCase().trim();

        //                 let isMatched = false;


        //                 if (offersObject__gift.mandatory_product_selector_presence == "either") {
        //                     $(`tbody[data-cart-line-items] .cart__row`).each(function () {

        //                         const collectVID = $(this).attr(`vid`) * 1;

        //                         if (offersObject__gift.mandatory_product_selectors.includes(collectVID)) {

        //                             isMatched = true;

        //                         }

        //                     })
        //                 } else {
        //                     isMatched = true;

        //                     $(`tbody[data-cart-line-items] .cart__row`).each(function () {

        //                         const collectVID = $(this).attr(`vid`) * 1;

        //                         if (!offersObject__gift.mandatory_product_selectors.includes(collectVID)) {

        //                             isMatched = false;

        //                         }

        //                     })
        //                 }


        //                 if (isMatched) {

        //                     if (typeof offersObject__gift.product_selectors !== 'undefined' && offersObject__gift.product_selectors) {

        //                         offersObject__gift.product_selectors.forEach(o => {

        //                             const getQTY = $(`.cart__row[vid="${o}"]`).attr(`data-cart-item-quantity`) * 1;
        //                             const properties = JSON.parse($(`.cart__row[vid="${o}"]`).attr(`data-properties`) || '[]');
        //                             var old_prop = properties.reduce(function (map, obj) {
        //                                 map[obj[0]] = obj[1];
        //                                 return map;
        //                             }, {});

        //                             old_prop[requiredAttribute] = true;

        //                             itemAdds.push({
        //                                 quantity: getQTY || 1,
        //                                 id: o,
        //                                 properties: {
        //                                     ...old_prop,
        //                                     'Promotion Name': automaticDiscount.promotion_code,
        //                                     _PromotionName: `${JSON.stringify(hiddenProperty)}`
        //                                 }
        //                             });

        //                         });

        //                     }

        //                 }

        //             } else {

        //                 gift__manadatoryProducts = null;

        //             }

        //         } else {

        //             offersObject__gift = null;

        //         }

        //         if (offerObject__notGift) {
        //             offerObject__notGift.forEach(async offersObject__manual => {

        //                 let requiredAttribute = automaticDiscount.promotion_code.toLowerCase().trim();

        //                 if (typeof offersObject__manual !== 'undefined' && offersObject__manual && discountCodes.some(discount => discount.startsWith(automaticDiscount.promotion_code))) {

        //                     if (typeof offersObject__manual.product_selectors !== 'undefined' && offersObject__manual.product_selectors) {

        //                         offersObject__manual.product_selectors.forEach(async o => {
        //                             if ($(`.cart__row[vid="${o}"]`).length > 0) {
        //                                 const getQTY = $(`.cart__row[vid="${o}"]`).attr(`data-cart-item-quantity`) * 1;
        //                                 const properties = JSON.parse($(`.cart__row[vid="${o}"]`).attr(`data-properties`) || '[]');
        //                                 var old_prop = properties.reduce(function (map, obj) {
        //                                     map[obj[0]] = obj[1];
        //                                     return map;
        //                                 }, {});

        //                                 old_prop[requiredAttribute] = true;

        //                                 var existItemUpdate = itemUpdates.find(x => x.id == o);

        //                                 if (existItemUpdate) {
        //                                     var indexItemExist = itemUpdates.findIndex(x => x.id == o);

        //                                     itemUpdates[indexItemExist] = {
        //                                         ...existItemUpdate,
        //                                         properties: {
        //                                             ...existItemUpdate.properties,
        //                                             ...old_prop
        //                                         }
        //                                     }

        //                                 } else {
        //                                     var itemUpdating = {
        //                                         id: `${o}`,
        //                                         quantity: getQTY || 1,
        //                                         properties: {
        //                                             ...old_prop
        //                                         }
        //                                     }

        //                                     itemUpdates.push(itemUpdating)
        //                                 }

        //                             }

        //                         });



        //                     }

        //                 }
        //             })
        //         }
        //     })

        // } else {
            

        // }

        /* manually gift */

        let appliedGiftCode = [];

        manualDiscountGiftObject = _customDiscount_.filter(x => x.offers.some(x => x.discount_type == "gift"));

        if (typeof manualDiscountGiftObject !== 'undefined' && manualDiscountGiftObject && discountCodes) {

            manualDiscountGiftObject.forEach(async manualDiscountGift => {

                let offersObject__gift = findObjectByKey(manualDiscountGift.offers, `discount_type`, `gift`);

                let discountCodeFound = discountCodes.find(discount => discount.startsWith(manualDiscountGift.promotion_code));

                if (typeof offersObject__gift !== 'undefined' && offersObject__gift && discountCodeFound) {
    
                    if (typeof offersObject__gift.manadatory_product_selectors !== 'undefined' && offersObject__gift.manadatory_product_selectors) {
    
                        const cartRowArray = document.querySelectorAll(`tbody[data-cart-line-items] .cart__row`);
    
                        const requiredAttribute = manualDiscountGift.promotion_code.toLowerCase().trim();
    
                        let isMatched = false;
    
    
                        if (offersObject__gift.manadatory_product_selector_presence == "either") {
                            $(`tbody[data-cart-line-items] .cart__row`).each(function () {
    
                                const collectVID = $(this).attr(`vid`) * 1;
    
                                if (offersObject__gift.manadatory_product_selectors.includes(collectVID)) {
    
                                    isMatched = true;
    
                                }
    
                            })
                        } else {
                            isMatched = true;
    
                            $(`tbody[data-cart-line-items] .cart__row`).each(function () {
    
                                const collectVID = $(this).attr(`vid`) * 1;
    
                                if (!offersObject__gift.manadatory_product_selectors.includes(collectVID)) {
    
                                    isMatched = false;
    
                                }
    
                            })
                        }
    
    
                        if (isMatched) {
    
                            if (typeof offersObject__gift.product_selectors !== 'undefined' && offersObject__gift.product_selectors) {

                                offersObject__gift.product_selectors.forEach(o => {
                                    const getQTY = $(`.cart__row[vid="${o}"]`).attr(`data-cart-item-quantity`) * 1;
                                    const properties = JSON.parse($(`.cart__row[vid="${o}"]`).attr(`data-properties`) || '[]');
                                    var old_prop = properties.reduce(function (map, obj) {
                                        map[obj[0]] = obj[1];
                                        return map;
                                    }, {});
    
                                    //old_prop[requiredAttribute] = true;
    
                                    if ($(`.cart__row[vid="${o}"]`).length <= 0) {
                                        itemAdds.push({
                                            quantity: getQTY || 1,
                                            id: o,
                                            properties: {
                                                ...old_prop,
                                                'Promotion Name': discountCodeFound,
                                                _PromotionName: `${discountCodeFound}`
                                            }
                                        });
                                    } else {
                                        itemUpdates.push({
                                            quantity: getQTY || 1,
                                            id: o,
                                            properties: {
                                                ...old_prop,
                                                'Promotion Name': discountCodeFound,
                                                _PromotionName: `${discountCodeFound}`
                                            }
                                        });
                                    }
    
                                });
    
                            }
    
                        }
    
                    } else {
    
                        gift__manadatoryProducts = null;
    
                    }

                } else {
    
                    offersObject__gift = null;
    
                }
            })

        } else {

        }

        const flatDiscounts = _customDiscount_.filter(x => x.flat_offer == 1 && x.exclusive_offer == 0);

        const validDiscountCodes = [];

        flatDiscounts.forEach(x => {
            if(x.promotion_code) {
                discountCodes.push(x.promotion_code);
            }
        })

        if(discountCodes) {
            discountCodes.forEach(code => {
                if (_customDiscount_.find(x => code.startsWith(x.promotion_code)) || (storageReferralCode && code == storageReferralCode)) {
                    validDiscountCodes.push(code);
                }
            })
    
            if(validDiscountCodes.length > 0){
                $('.cart__row[data-cart-item]').each(function(v) {
                    const vid = $(this).attr('vid');
    
                    const existItemItemAdd = itemAdds.filter(x => x.id == vid);
                    const existItemItemUpdate = itemUpdates.filter(x => x.id == vid);
                    const currentRowItem = tbn_cart.items.find(x => x.id == vid);
    
                    const res = validDiscountCodes.reduce((acc,curr)=> (acc[curr]='true',acc),{});
    
                    if(existItemItemAdd.length > 0) {
                        const indexItemAdd = itemAdds.findIndex(x => x.id == vid);
    
                        itemAdds[indexItemAdd] = {
                            ...existItemItemAdd[0],
                            properties:{
                                ...currentRowItem.properties,
                                ...res,
                                'Promotion Name': validDiscountCodes.join(','),
                                _PromotionName: `${validDiscountCodes.join(',')}`,
                                
                            }
                        }
                    }else if (existItemItemUpdate.length > 0 ) {
                        const indexItemAdd = itemUpdates.findIndex(x => x.id == vid);
    
                        itemUpdates[indexItemAdd] = {
                            ...existItemItemUpdate[0],
                            properties:{
                                ...currentRowItem.properties,
                                ...res,
                                'Promotion Name': validDiscountCodes.join(','),
                                _PromotionName: `${validDiscountCodes.join(',')}`
                            }
                        }
                    }else {
                        const getQTY = $(this).attr(`data-cart-item-quantity`) * 1;
    
                        itemUpdates.push({
                            quantity: getQTY || 1,
                            id: vid,
                            properties: {
                                ...currentRowItem.properties,
                                ...res,
                                'Promotion Name': validDiscountCodes.join(','),
                                _PromotionName: `${validDiscountCodes.join(',')}`
                            }
                        });
                    }
                })
            }
        }

        if(itemUpdates.length > 0 || itemAdds.length > 0) {

            let updateData = '';
    
            itemUpdates.forEach((it, i) => {
    
                if (i == 0) {
    
                    updateData = `updates[${it.id}]=0`;
    
                } else {
    
                    updateData += `&updates[${it.id}]=0`
    
                }
            })

            itemAdds.forEach((it, i) => {
                if(updateData.length > 0) {
                    updateData += `&updates[${it.id}]=0`
                }else {
                    updateData = `updates[${it.id}]=0`;
                }
            });
    
            //await $.post(`/cart/update.js`, `${updateData}`);

                        
            //await $.post(`/cart/add.js`, { items: itemAdds.concat(itemUpdates) }, function (r) { }, "json");

            if (typeof getCartItems === 'function') {

                await getCartItems();

                await checkReferral();

            }
    
        }

    })


manualDiscountObject = findObjectByKey(_customDiscount_, `trigger_type`, `manual`);

if (typeof manualDiscountObject !== 'undefined' && manualDiscountObject) {

    manualDiscountObject = manualDiscountObject;

    if (typeof manualDiscountObject.offers[0].product_selectors !== 'undefined' && manualDiscountObject.offers[0].product_selectors) {

        referral_manadatoryProducts = manualDiscountObject.offers[0].product_selectors;

    } else {

        referral_manadatoryProducts = null;

    }

} else {

    manualDiscountObject = null;

}

influencerDiscountObject = findObjectByKey(_customDiscount_, `trigger_type`, `influencer`);

console.log(`influencerDiscountObject`, influencerDiscountObject);

if (typeof influencerDiscountObject !== 'undefined' && influencerDiscountObject) {

    influencerDiscountObject = influencerDiscountObject;

    if (typeof influencerDiscountObject.offers[0].product_selectors !== 'undefined' && influencerDiscountObject.offers[0].product_selectors) {

        influencer_manadatoryProducts = influencerDiscountObject.offers[0].product_selectors;

    } else {

        influencer_manadatoryProducts = null;

    }

} else {

    influencerDiscountObject = null;

}

hiddenProperty = [];

offersObject__gift = [];

//checkReferral();

window.onbeforeunload = function () {

    // localStorage.removeItem( `__offerSelected__` );

};

$(document)
    .ready(async function () {

        // console.log(`manualDiscountObject`, manualDiscountObject);
        // console.log(`referral_manadatoryProducts`, referral_manadatoryProducts);
        // console.log(`influencer_manadatoryProducts`, influencer_manadatoryProducts);

        console.log('automaticDiscountObject', automaticDiscountObject);

        if (typeof storageReferralCode !== 'undefined' && storageReferralCode && typeof isCustomerRR !== 'undefined' && isCustomerRR == 'Yes') {

            let getCode = '';

            $(`tbody[data-cart-line-items] .cart__row`).each(function () {

                getCode += $(this).find(`.product-details .product-details__item span[data-cart-item-property-value]`).text();

            })

            console.log(`getCode`, getCode);

            const getSelectedCode = $(`.discountWrapper__item.disabled`).attr(`code`);

            if (getCode.includes(getSelectedCode) == false) {

                console.log(`getSelectedCode`, getSelectedCode);

                await $(`.discountWrapper__item.disabled .btn-offer-apply`).click();

            }

        }

        await $(`.discountWrapper__item[index="1"] .btn-offer-apply`).click();

        await $.get(`/cart.js`, function (data) {

            if (typeof data.total_discount !== 'undefined' && data.total_discount) {

                let totalDiscount = (data.total_discount) / 100;
                totalDiscount = totalDiscount.toFixed(2);

                let currencyRate = Shopify.currency.rate * discountAmount;
                let discountedAmount = currencyRate.toFixed(2);

                let totalAdditionalDiscount = data.total_discount - (Shopify.currency.rate * discountAmount * 100) + (currencyRate * 100);
                totalAdditionalDiscount = totalAdditionalDiscount / 100;
                totalAdditionalDiscount = totalAdditionalDiscount.toFixed(2);

                $(`.discountWrapper__item[index="1"] .discountWrapper__item__detail_ b`).text(`${totalDiscount} ${Shopify.currency.active}`);
                $(`.discountWrapper__item[index="2"] .discountWrapper__item__detail_ b[no="1"]`).text(`${discountedAmount} ${Shopify.currency.active}`);
                $(`.discountWrapper__item[index="2"] .discountWrapper__item__detail_ b[no="2"]`).text(`${totalAdditionalDiscount} ${Shopify.currency.active}`);

                $(`.discountWrapper__item.disabled[index="2"] .discountWrapper__item__detail_ b[no="2"]`).text(`${totalDiscount} ${Shopify.currency.active}`);

            }

        }, "json");

        let isDataAvailable = $(`.discountWrapper_ .discountWrapper`).html();
        isDataAvailable = isDataAvailable.trim();

        if (isDataAvailable == '') {

            $(`.discountWrapper_ .couponTitle`).remove();

        }

        const selectedOffer = localStorage.getItem(`__offerSelected__`);

        if (typeof selectedOffer !== 'undefined' && selectedOffer) {

            await delay(100);

            $(`.discountWrapper__item[index="2"][code="${selectedOffer}"] .btn-offer-apply`).click();

        }

        if (typeof storageReferralCode !== 'undefined' && storageReferralCode && typeof isCustomerRR !== 'undefined' && isCustomerRR == 'Yes') {

            const checkItemTypeMachineAvailable = $(`.cartItemLoop .cart__row[product-type="Machine"]`).length;
            const rrElementDisabled = $(`.discountWrapper__item[index="2"]:not( .disabled )`).length;

            if (checkItemTypeMachineAvailable > 0 && rrElementDisabled > 0) {

                await $(`.discountWrapper__item[index="2"]:not( .disabled ) .btn-offer-apply`).click();

            }

            console.log('checkItemTypeMachineAvailable', checkItemTypeMachineAvailable);

        }

        if (!isCustomerRR || isCustomerRR == 'No') {
            document.querySelector(`.discountWrapper_`).remove();
        }


        $(`#preloader_cart`).remove();

    })

    .on(`click`, `.discountWrapper__item.disabled[index="2"]`, function () {

        localStorage.removeItem(`__offerSelected__`);

        location.href = `/cart`;

    })
    .on(`click`, `.discountWrapper__item .btn-offer-apply`, async function (isAuto) {
        try {

            $(`#preloader`).show();

            console.log(`automaticDiscountObject`, automaticDiscountObject);
            console.log(`offersObject__gift`, offersObject__gift);
            // console.log(`gift__manadatoryProducts`, gift__manadatoryProducts);
            console.log(`manualDiscountObject`, manualDiscountObject);
            console.log(`influencerDiscountObject`, influencerDiscountObject);

            $(`.discountWrapper .discountWrapper__item.disabled`).removeClass(`disabled`).addClass(`selected`);
            // $( `.discountWrapper .discountWrapper__item` ).removeClass( `disabled` );

            $(this).closest(`.discountWrapper__item`).addClass(`disabled`);

            const getCode = $(this).closest(`.discountWrapper__item`).attr(`code`);

            if (hiddenProperty.includes(getCode) === false) {

                hiddenProperty.push(getCode);

            }

            const cartRowArray = document.querySelectorAll(`tbody[data-cart-line-items] .cart__row`);

            const clickedOfferTitle = $(this).closest(`.discountWrapper__item`).attr(`block-title`);


            // const automaticOfferName = automaticDiscountObject.promotion_name.toLowerCase();

            // const manualOfferName = manualDiscountObject.promotion_name.toLowerCase();

            // const incluencerOfferName = influencerDiscountObject.promotion_name.toLowerCase();

            // if (automaticOfferName == clickedOfferTitle) {

            //     let items = [];

            //     for (const el of cartRowArray) {
            //         const vid = el.getAttribute(`vid`) * 1;
            //         const qty = el.getAttribute(`data-cart-item-quantity`) * 1;
            //         const properties = JSON.parse(el.getAttribute(`data-properties`) || '[]');
            //         var old_prop = properties.reduce(function (map, obj) {
            //             map[obj[0]] = obj[1];
            //             return map;
            //         }, {});

            //         if (typeof offersObject__gift.product_selectors !== 'undefined' && offersObject__gift.product_selectors.includes(vid) == false) {

            //             const checkObject = await findObjectByKey(items, 'id', vid);

            //             if (typeof checkObject !== 'undefined' && checkObject) {

            //             } else {

            //                 items.push({
            //                     quantity: qty,
            //                     id: vid,
            //                     properties: {
            //                         ...old_prop,
            //                         'Promotion Name': automaticDiscountObject.promotion_code,
            //                         _PromotionName: `${JSON.stringify(hiddenProperty)}`
            //                     }
            //                 });

            //             }

            //         }
            //     }

            //     let isMatched = false;

            //     $(`tbody[data-cart-line-items] .cart__row`).each(function () {

            //         const collectVID = $(this).attr(`vid`) * 1;

            //         if (offersObject__gift.mandatory_product_selectors.includes(collectVID)) {

            //             isMatched = true;

            //         }

            //     })

            //     if (items.length > 0 && isMatched) {

            //         await $.post("/cart/clear.js", function (r) { }, "json");

            //         await delay(2000);

            //         localStorage.setItem(`__referralRedirect__`, getCode);

            //         if (typeof offersObject__gift.product_selectors !== 'undefined' && offersObject__gift.product_selectors) {

            //             offersObject__gift.product_selectors.forEach(o => {

            //                 const getQTY = $(`.cart__row[vid="${o}"]`).attr(`data-cart-item-quantity`) * 1;
            //                 const properties = JSON.parse($(`.cart__row[vid="${o}"]`).attr(`data-properties`) || '[]');
            //                 var old_prop = properties.reduce(function (map, obj) {
            //                     map[obj[0]] = obj[1];
            //                     return map;
            //                 }, {});

            //                 items.push({
            //                     quantity: getQTY,
            //                     id: o,
            //                     properties: {
            //                         ...old_prop,
            //                         'Promotion Name': automaticDiscountObject.promotion_code,
            //                         _PromotionName: `${JSON.stringify(hiddenProperty)}`
            //                     }
            //                 });

            //             });

            //         }

            //         console.log(`items yes`, items);

            //         await $.post(`/cart/add.js`, { items }, function (r) { }, "json");

            //         if (typeof getCartItems === 'function') {

            //             await getCartItems();

            //         }

            //     }

            // } else if (manualOfferName == clickedOfferTitle) {

            //     console.log('are in manual');

            //     let cartItemsVID = [];

            //     $(`tbody[data-cart-line-items] .cart__row`).each(function () {
            //         const vid = $(this).attr(`vid`) * 1;

            //         if (vid) {
            //             cartItemsVID.push(vid);
            //         }

            //     })

            //     let regularVIDs = [];
            //     applyRegularwithRR = false;


            //     automaticDiscountObject.offers.forEach(el => {
            //         if (el.product_selectors && el.product_selectors.length) {
            //             if (el.discount_type === 'gift') {
            //                 regularVIDs = regularVIDs.concat(el.mandatory_product_selectors);
            //             } else {
            //                 regularVIDs = regularVIDs.concat(el.product_selectors);

            //             }
            //         }
            //     });
            //     regularVIDs.filter(el => {
            //         console.log('CHECKING el', el)
            //         if (cartItemsVID.findIndex(ci => ci == el) >= 0) {
            //             console.log('MATCHED (IT IS PRESENT INSIDE REGULAR)', el)
            //             applyRegularwithRR = true;
            //         }
            //     })


            //     console.log('cartItemsVID', cartItemsVID);
            //     console.log('regularVIDs', regularVIDs);

            //     let updateData;

            //     if (typeof offersObject__gift !== 'undefined' && offersObject__gift && typeof offersObject__gift.product_selectors !== 'undefined' && offersObject__gift.product_selectors) {
            //         offersObject__gift.product_selectors.forEach((offerSelectors, i) => {

            //             if (i == 0) {

            //                 updateData = `updates[${offerSelectors}]=0`;

            //             } else {

            //                 updateData += `&updates[${offerSelectors}]=0`

            //             }

            //         })

            //     }

            //     console.log(`updateData`, updateData);

            //     if (typeof offersObject__gift !== 'undefined' && offersObject__gift && typeof offersObject__gift.product_selectors !== 'undefined' && offersObject__gift.product_selectors) {

            //         if (offersObject__gift.product_selectors.length > 0) {

            //             let isMatched = false;

            //             $(`tbody[data-cart-line-items] .cart__row`).each(function () {

            //                 const collectVID = $(this).attr(`vid`) * 1;

            //                 if (offersObject__gift.mandatory_product_selectors.includes(collectVID)) {

            //                     // isMatched   =   true;

            //                 }

            //             })

            //             if (isMatched) {

            //                 localStorage.setItem(`__referralRedirect__`, getCode);

            //                 await $.post(`/cart/update.js`, `${updateData}`);

            //                 await cartItemsOnly();

            //                 const cartJsData = await cartJs();

            //                 console.log('cartJsData', cartJsData);

            //             }

            //         }

            //     }


            //     items = [];

            //     console.log(`items`, items);

            //     console.log(`start chaaa manual`);

            //     const cartRowArray_ = document.querySelectorAll(`tbody[data-cart-line-items] .cart__row`);

            //     for (const el of cartRowArray_) {
            //         const vid = el.getAttribute(`vid`) * 1;
            //         const qty = el.getAttribute(`data-cart-item-quantity`) * 1;
            //         const properties = JSON.parse(el.getAttribute(`data-properties`) || '[]');
            //         var old_prop = properties.reduce(function (map, obj) {
            //             map[obj[0]] = obj[1];
            //             return map;
            //         }, {});

            //         const checkObject = await findObjectByKey(items, 'id', vid);

            //         if (typeof checkObject !== 'undefined' && checkObject) {

            //         } else {

            //             items.push({
            //                 id: vid,
            //                 quantity: qty,
            //                 properties: {
            //                     ...old_prop,
            //                     'Promotion Name': manualDiscountObject.promotion_code,
            //                     _PromotionName: `${JSON.stringify(hiddenProperty)}`
            //                 }
            //             });

            //         }
            //     }

            //     await delay(500);

            //     if (items.length > 0) {

            //         console.log(`items`, items);

            //         localStorage.setItem(`__referralRedirect__`, getCode);

            //         await $.post("/cart/clear.js", function (r) { }, "json");

            //         await $.post(`/cart/add.js`, { items }, function (r) { }, "json");

            //     }

            //     if (typeof cartItemsOnly === 'function') {

            //         await cartItemsOnly();

            //     }

            //     localStorage.setItem(`__offerSelected__`, getCode);

            //     console.log('applyRegularwithRR', applyRegularwithRR);

            //     if (applyRegularwithRR == false) {

            //         $(`.discountWrapper__item[code="RT-REGULAR-OFFER"]`).remove();

            //         const cartJsData = await cartJs();

            //         const getRT_REFERRAL_OFFER_DiscountAmount = $(`.discountWrapper__item[code="RT-REFERRAL-OFFER"]`).attr(`discount-amount`) * 1;

            //         console.log('cartJsData', cartJsData);

            //         if (typeof cartJsData.total_discount !== 'undefined' && cartJsData.total_discount) {
            //             $(`.discountWrapper__item[code="RT-REFERRAL-OFFER"] .discountWrapper__item__detail_ b[no="1"]`).text(`${Shopify.currency.active} ${getRT_REFERRAL_OFFER_DiscountAmount * Shopify.currency.rate}`);
            //             $(`.discountWrapper__item[code="RT-REFERRAL-OFFER"] .discountWrapper__item__detail_ b[no="2"]`).text(`${Shopify.currency.active} ${(cartJsData.total_discount / 100)}`);
            //         }

            //     } else {
            //         await $.get(`/cart.js`, function (data) {

            //             if (typeof data.total_discount !== 'undefined' && data.total_discount) {

            //                 let totalDiscount = (data.total_discount) / 100;
            //                 totalDiscount = totalDiscount.toFixed(2);

            //                 let currencyRate = Shopify.currency.rate * discountAmount;
            //                 let discountedAmount = currencyRate.toFixed(2);

            //                 let totalAdditionalDiscount = data.total_discount - (Shopify.currency.rate * discountAmount * 100) + (currencyRate * 100);
            //                 totalAdditionalDiscount = totalAdditionalDiscount / 100;
            //                 totalAdditionalDiscount = totalAdditionalDiscount.toFixed(2);

            //                 $(`.discountWrapper__item[index="1"] .discountWrapper__item__detail_ b`).text(`${totalDiscount} ${Shopify.currency.active}`);
            //                 $(`.discountWrapper__item[index="2"] .discountWrapper__item__detail_ b[no="1"]`).text(`${discountedAmount} ${Shopify.currency.active}`);
            //                 $(`.discountWrapper__item[index="2"] .discountWrapper__item__detail_ b[no="2"]`).text(`${totalAdditionalDiscount} ${Shopify.currency.active}`);

            //                 $(`.discountWrapper__item.disabled[index="2"] .discountWrapper__item__detail_ b[no="2"]`).text(`${totalDiscount} ${Shopify.currency.active}`);

            //             }

            //         }, "json");
            //     }

            // } else if (incluencerOfferName == clickedOfferTitle) {

            //     let updateData;

            //     if (typeof offersObject__gift.product_selectors !== 'undefined' && offersObject__gift.product_selectors) {
            //         offersObject__gift.product_selectors.forEach((offerSelectors, i) => {

            //             if (i == 0) {

            //                 updateData = `updates[${offerSelectors}]=0`;

            //             } else {

            //                 updateData += `&updates[${offerSelectors}]=0`

            //             }

            //         })

            //     }

            //     // console.log(`updateData`, updateData);

            //     if (typeof offersObject__gift.product_selectors !== 'undefined' && offersObject__gift.product_selectors.length > 0) {

            //         let isMatched = false;

            //         $(`tbody[data-cart-line-items] .cart__row`).each(function () {

            //             const collectVID = $(this).attr(`vid`) * 1;

            //             if (offersObject__gift.mandatory_product_selectors.includes(collectVID)) {

            //                 // isMatched   =   true;

            //             }

            //         })

            //         if (isMatched) {

            //             localStorage.setItem(`__referralRedirect__`, getCode);

            //             await $.post(`/cart/update.js`, `${updateData}`);

            //             await getCartItems();

            //         }

            //     }


            //     items = [];

            //     console.log(`items`, items);

            //     console.log(`start chaaa incluencer`);

            //     const cartRowArray_ = document.querySelectorAll(`tbody[data-cart-line-items] .cart__row`);

            //     for (const el of cartRowArray_) {
            //         const vid = el.getAttribute(`vid`) * 1;
            //         const qty = el.getAttribute(`data-cart-item-quantity`) * 1;
            //         const properties = JSON.parse(el.getAttribute(`data-properties`) || '[]');
            //         var old_prop = properties.reduce(function (map, obj) {
            //             map[obj[0]] = obj[1];
            //             return map;
            //         }, {});

            //         const checkObject = await findObjectByKey(items, 'id', vid);

            //         if (typeof checkObject !== 'undefined' && checkObject) {

            //         } else {

            //             items.push({
            //                 id: vid,
            //                 quantity: qty,
            //                 properties: {
            //                     ...old_prop,
            //                     'Promotion Name': influencerDiscountObject.promotion_code,
            //                     _PromotionName: `${JSON.stringify(hiddenProperty)}`
            //                 }
            //             });

            //         }
            //     }

            //     await delay(500);

            //     if (items.length > 0) {

            //         console.log(`items`, items);

            //         localStorage.setItem(`__referralRedirect__`, getCode);

            //         await $.post("/cart/clear.js", function (r) { }, "json");

            //         await $.post(`/cart/add.js`, { items }, function (r) { }, "json");

            //     }

            //     if (typeof getCartItems === 'function') {

            //         await getCartItems();

            //     }

            //     localStorage.setItem(`__offerSelected__`, getCode);

            // }

            $(`.discountWrapper__item__btn .btn-offer-apply`).text(`APPLY`);

            $(`.discountWrapper__item.selected .discountWrapper__item__btn .btn-offer-apply`).text(`APPLIED`);

            $(this).text(`APPLIED`);

            rrPriceCalc();

            $(`#preloader`).hide();

        }
        catch (err) {
            console.log(`ERROR .discountWrapper__item .btn-offer-apply`, err.message);
        }
    });

function rrPriceCalc() {
    try {

        if (typeof storageReferralCode !== 'undefined' && storageReferralCode && typeof isCustomerRR !== 'undefined' && isCustomerRR == 'Yes') {

            let block1_price = $(`.discountWrapper__item.selected[index="1"] .discountWrapper__item__detail_ b[no="1"]`).text();
            block1_price = block1_price.replace(` ${Shopify.currency.active}`, '');
            block1_price = block1_price * 1;

            let block2_price = $(`.discountWrapper__item.disabled[index="2"] .discountWrapper__item__detail_ b[no="2"]`).text();
            block2_price = block2_price.replace(` ${Shopify.currency.active}`, '');
            block2_price = block2_price * 1;

            let anotherDiscountAttr = $(`.discountWrapper__item.disabled[index="2"]`).attr(`discount-amount`) * 1;
            anotherDiscountAttr = Shopify.currency.rate * anotherDiscountAttr;
            // anotherDiscountAttr       =   anotherDiscountAttr.replace(  ` ${ Shopify.currency.active }`, '' );
            // anotherDiscountAttr       =   anotherDiscountAttr * 1;

            if (typeof block1_price !== 'undefined' && block1_price && typeof block2_price !== 'undefined' && block2_price && typeof anotherDiscountAttr !== 'undefined' && anotherDiscountAttr) {

                if (block1_price == block2_price) {

                    let substractDiscount = block1_price - anotherDiscountAttr;

                    let additionDiscount = substractDiscount + anotherDiscountAttr;
                    additionDiscount = additionDiscount.toFixed(2);

                    $(`.discountWrapper__item.selected[index="1"] .discountWrapper__item__detail_ b[no="1"]`).text(`${substractDiscount} ${Shopify.currency.active}`);

                    $(`.discountWrapper__item.disabled[index="2"] .discountWrapper__item__detail_ b[no="2"]`).text(`${additionDiscount} ${Shopify.currency.active}`);

                    console.log('block1_price', block1_price);
                    console.log('block2_price', block2_price);
                    console.log('anotherDiscountAttr', anotherDiscountAttr);

                }

            }

        }

    }
    catch (err) {
        console.log(`ERROR `, err.message);
    }
}

function checkReferral() {
    try {

        console.log('_customDiscount_', _customDiscount_);

        if (_customDiscount_.length > 0) {

            for (const o of _customDiscount_) {

                const getPromotionName = o.promotion_name.toLowerCase();

                // console.log(`getPromotionName`, getPromotionName);

                const el = document.querySelector(`.discountWrapper__item[code="${o.promotion_code}"]`);
                el?.setAttribute(`block-title`, getPromotionName);

            }

        }

        const availableMachineVariants = [];

        $(`tbody[data-cart-line-items] .cart__row[product-type="Machine"]`).each(function () {

            const machineVariant = $(this).attr(`vid`) * 1;
            availableMachineVariants.push(machineVariant);

        })

        const storagePromotionCode = localStorage.getItem(`__homePageRR__`);

        if (typeof storagePromotionCode !== 'undefined' && storagePromotionCode) {

            const getIndexNumber = document.querySelector(`.discountWrapper__item[code="${storagePromotionCode}"]`).getAttribute(`index`);

            if (getIndexNumber == 2) {

                discountAmount = document.querySelector(`.discountWrapper__item[index="2"]`).getAttribute(`discount-amount`) * 1;

                // discountAmount            =   Shopify.currency.rate * discountAmount;

                // document.querySelector( `.discountWrapper__item[index="2"]` ).setAttribute( `discount-amount`, discountAmount );

                // console.log ( 'discountAmount', discountAmount );

                document.querySelector(`.discountWrapper__item[index="3"]`).remove();

            } else if (getIndexNumber == 3) {

                discountAmount = document.querySelector(`.discountWrapper__item[index="3"]`).getAttribute(`discount-amount`) * 1;

                // discountAmount            =   Shopify.currency.rate * discountAmount;

                // document.querySelector( `.discountWrapper__item[index="3"]` ).setAttribute( `discount-amount`, discountAmount );

                // console.log ( 'discountAmount', discountAmount );

                document.querySelector(`.discountWrapper__item[index="2"]`).remove();
                document.querySelector(`.discountWrapper__item[index="3"]`).setAttribute(`index`, `2`);

            }

        }

        if (typeof storageReferralCode !== 'undefined' && storageReferralCode && typeof isCustomerRR !== 'undefined' && isCustomerRR == 'Yes') {

            const storagePromotionCode = localStorage.getItem(`__referralRedirect__`);

            if (typeof storagePromotionCode !== 'undefined' && storagePromotionCode) {

                const discountItemArr = document.querySelectorAll(`.discountWrapper__item`);

                discountItemArr.forEach(el => {
                    el.classList.remove(`disabled`);
                });

                // document.querySelector( `.discountWrapper__item[code="${ storagePromotionCode }"]` ).classList.add( `disabled` );

                const homePageRR = localStorage.getItem(`__homePageRR__`);

                let variantMatched = false;

                if (typeof homePageRR !== 'undefined' && homePageRR) {

                    const getPromotionCodeObject = findObjectByKey(_customDiscount_, 'promotion_code', homePageRR);

                    if (typeof getPromotionCodeObject !== 'undefined' && getPromotionCodeObject) {

                        console.log(`availableMachineVariants`, availableMachineVariants);

                        if (getPromotionCodeObject.trigger_type == 'manual') {

                            // console.log(`referral_manadatoryProducts`, referral_manadatoryProducts);

                            if (availableMachineVariants.length > 0) {

                                for (const o of availableMachineVariants) {

                                    if (referral_manadatoryProducts.includes(o)) {

                                        variantMatched = true;

                                        break;

                                    }

                                }

                            }

                        } else if (getPromotionCodeObject.trigger_type == 'influencer') {

                            console.log(`influencer_manadatoryProducts`, influencer_manadatoryProducts);

                            for (const o of availableMachineVariants) {

                                if (influencer_manadatoryProducts.includes(o)) {

                                    variantMatched = true;

                                    break;

                                }

                            }

                        }

                    }

                    console.log(`getPromotionCodeObject`, getPromotionCodeObject);

                }

                if (variantMatched == false) {

                    if (document.querySelector(`.discountWrapper__item[index="2"]`)) {
                        document.querySelector(`.discountWrapper__item[index="2"]`).remove();
                    }

                    if (document.querySelector(`.discountWrapper__item[index="3"]`)) {
                        document.querySelector(`.discountWrapper__item[index="3"]`).remove();
                    }

                    // document.querySelector( `.discountWrapper_` ).style.display = 'none';

                }

            }

        } else {

            if (document.querySelector(`.discountWrapper__item[index="2"]`)) {
                document.querySelector(`.discountWrapper__item[index="2"]`).remove();
            }

            if (document.querySelector(`.discountWrapper__item[index="3"]`)) {
                document.querySelector(`.discountWrapper__item[index="3"]`).remove();
            }

            document.querySelector(`.discountWrapper_`).style.display = 'none';

        }

        let variantMatchedRegular = false;

        if (availableMachineVariants.length > 0) {

            for (const o of availableMachineVariants) {

                if (typeof gift__manadatoryProducts !== 'undefined' && gift__manadatoryProducts.includes(o)) {

                    variantMatchedRegular = true;

                    break;

                }

            }

        }

        console.log(`variantMatchedRegular`, variantMatchedRegular);

        if (variantMatchedRegular == false) {

            if (document.querySelector(`.discountWrapper__item[index="1"]`)) {
                // document.querySelector( `.discountWrapper__item[index="1"]` ).remove();
            }

        }

    } catch (err) {
        console.log(`ERROR checkReferral`, err.message);
    }

}

async function getPrices() {

    let discountObjectOriginalPrice = 0;
    let discountObjectFinalPrice = 0;

    $(`tbody[data-cart-line-items] .cart__row`).each(function () {

        let originalPrice = $(this).attr(`original-price`);
        let finalPrice = $(this).attr(`final-price`);
        let qty = $(this).attr(`data-cart-item-quantity`);

        originalPrice = originalPrice.replace(`,`, ``) * 1;
        finalPrice = finalPrice.replace(`,`, ``) * 1;

        discountObjectOriginalPrice += originalPrice * qty;
        discountObjectFinalPrice += finalPrice;

    });

    discountObjectOriginalPrice = discountObjectOriginalPrice.toFixed(2);
    discountObjectFinalPrice = discountObjectFinalPrice.toFixed(2);
    let discountedPrice = discountObjectOriginalPrice - discountObjectFinalPrice;
    discountedPrice = discountedPrice.toFixed(2);

    return ({
        original_price_total: discountObjectOriginalPrice,
        final_price_total: discountObjectFinalPrice,
        discount: discountedPrice > 0 ? discountedPrice : 0
    });
}

async function updateDiscountPrice() {
    let discountObjectOriginalPrice = 0;
    let discountObjectFinalPrice = 0;

    $(`tbody[data-cart-line-items] .cart__row`).each(function () {

        let originalPrice = $(this).attr(`original-price`);
        let finalPrice = $(this).attr(`final-price`);
        let qty = $(this).attr(`data-cart-item-quantity`);

        qty = qty * 1;
        originalPrice = originalPrice.replace(`,`, ``) * 1;
        finalPrice = finalPrice.replace(`,`, ``) * 1;

        originalPrice = originalPrice * qty;
        // finalPrice                    =   finalPrice * qty;

        console.log(`finalPrice`, finalPrice);
        console.log(`originalPrice`, originalPrice);

        discountObjectOriginalPrice += originalPrice;
        discountObjectFinalPrice += finalPrice;

    });

    discountObjectOriginalPrice = discountObjectOriginalPrice.toFixed(2);
    discountObjectFinalPrice = discountObjectFinalPrice.toFixed(2);
    let discountedPrice = discountObjectOriginalPrice - discountObjectFinalPrice;
    discountedPrice = discountedPrice.toFixed(2);

    console.log(`discountObjectOriginalPrice`, discountObjectOriginalPrice);
    console.log(`discountObjectFinalPrice`, discountObjectFinalPrice);

    return ({
        original_price_total: discountObjectOriginalPrice,
        final_price_total: discountObjectFinalPrice,
        discount: discountedPrice > 0 ? discountedPrice : 0
    });
}